import React from "react";
import { Redirect } from "react-router";
// import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import fontb from '../../btitr.ttf';
import ReactFontFace from 'react-font-face'
let fontConfig = {

  file: [
    {
      fontFamily: 'Bangers',
      fontStyle:  'normal',
      fontWeight: 400,
      // unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
      file: fontb,
      fontType: 'truetype',
      fileLocal: 'Bangers Regular'
    },
    
  
  ]
}
 class ActiveAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ActivationToken:props.location.search,
      TranseferLoginPage:false
  }
  console.log(this.state. ActivationToken)
  }
  
  componentDidMount(){
    const user= this.state.ActivationToken.split('?');
//      fetch("http://conalysis.ihcs.ac.ir:8080/signupActive", {
      fetch("http://conalysis.ihcs.ac.ir:8080/signupActive", {

      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token:user[2],
        email:user[1],
        // Password: this.state.Password,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if(responseJson.status=='success'){
          this.setState({
            TranseferLoginPage:true

        })

        }
       
        
      })
      .catch((error) => { 
        console.log(error);
      });

      setTimeout(() => {
        // var chart1 = this.chart;
        this.setState({
          back:true
        })
      }, 3000);
  }
  render() {
    
   if(this.state.TranseferLoginPage){
    return (
      <div>
      <div style={{textAlign:"center",fontSize:30,fontWeight:300,fontFamily:'Bangers',marginTop:"20%"}}>
        حساب با موفقیت فعال شد به صفحه ورود هدایت می شوید
      </div>
      {this.state.back ?  <Redirect
          to={{
            pathname: "/",
           
          }}
        /> :null}
     </div>
      );

   }
   else if(this.state.ActivationToken && this.state.TranseferLoginPage==false){
    const user= this.state.ActivationToken.split('?');

     return(
       <div>
       <div>
{user[2]}
       </div>
          <div>
          {user[1]}
                 </div>
                 </div>
     )
   }
   else {
     return(
       null
     )
   }
    
  }
 


}
// export default ActiveAccount;
export default ReactFontFace(ActiveAccount, fontConfig);
